import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  body: string;
}

export const RedirectModal = (props: Props) => {
  return (
    <Modal show={true}>
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6 className="text-center">{props.body}</h6>
        <Modal.Footer>
          <div className="mx-auto">
            <Button variant="secondary" className="m-2">
              <Link to="/" style={{ color: 'black' }}>
                Dashboard
              </Link>
            </Button>
            <Button variant="secondary" className="m-2">
              <Link to="/Admin/viewUsers" style={{ color: 'black' }}>
                All Users
              </Link>
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};
